import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["log", "input", "form", "pauseButton", "sendButton"]
  static values = { npc: String, url: String, history: { type: Array, default: [] }, paused: { type: Boolean, default: false } }

  togglePause() {
    this.pausedValue = !this.pausedValue
    this.inputTarget.disabled = this.pausedValue
    this.sendButtonTarget.disabled = this.pausedValue
    this.pauseButtonTarget.textContent = this.pausedValue ? "Resume" : "Pause"
    this.logTarget.classList.toggle("opacity-40", this.pausedValue)
    if (this.pausedValue) {
      this.inputTarget.placeholder = `${this.npcValue} is paused...`
    } else {
      this.inputTarget.placeholder = `Say something to ${this.npcValue}...`
      this.inputTarget.focus()
    }
  }

  submit(event) {
    event.preventDefault()
    if (this.pausedValue) return
    const text = this.inputTarget.value.trim()
    if (!text) return

    this.appendMessage("You", text)
    this.inputTarget.value = ""
    this.inputTarget.disabled = true

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ text, history: JSON.stringify(this.historyValue) })
    })
      .then((response) => response.json())
      .then((data) => {
        this.historyValue = data.history
        this.appendMessage(this.npcValue, data.reply)
      })
      .catch((error) => {
        this.appendMessage("Error", error.message)
      })
      .finally(() => {
        this.inputTarget.disabled = false
        this.inputTarget.focus()
      })
  }

  appendMessage(speaker, text) {
    const line = document.createElement("p")
    line.classList.add("mb-3")
    const label = document.createElement("span")
    label.classList.add("font-heading", "text-tavern-gold")
    label.textContent = `${speaker}: `
    line.appendChild(label)
    line.appendChild(document.createTextNode(text))
    this.logTarget.appendChild(line)
    this.logTarget.scrollTop = this.logTarget.scrollHeight
  }
}
